/** Fixed EmailInfoDtl presets for Study Configuration (stt.EmailInfoDtl). */

const SHARED_SMS = {
  smtpPortNo: 1,
  smsUrl: 'http://www.smsjust.com/sms/user/urlsms.php?',
  smsUser: 'SARJENSYSTEMS',
  smsPwd: 'S$pl@4321!',
  smsSender: 'SARJEN',
  smsResponse: 'Y',
  authSecretKey: false,
  isActive: true,
  recordedAtTimeZone: null,
  replicaFlag: null,
  internationalSmsUrl: 'https://control.msg91.com/api/v5/flow',
  internationalSmsAuthKey: '314749AzsDsYIu68b034adP1',
};

export const EMAIL_GATEWAY_PRESETS = {
  sarjen: {
    presetKey: 'sarjen',
    presetLabel: 'Sarjen',
    smsGatewayNo: 1,
    ...SHARED_SMS,
    fromEmail: 'biznet.dev@sarjen.com',
    password: 'G!032479800023op',
    tenantId: '0c32b961-2f93-4aa3-86fa-8acf460d1662',
    clientId: 'ff6b9f97-d266-4da4-8e24-613f1a79e7e0',
    secretKey: 'ldx8Q~KuiYmQ-2M.VljggeABbkTxulKBMYq.tbZV',
    clearSecretKey: false,
  },
  ltr: {
    presetKey: 'ltr',
    presetLabel: 'LTR',
    smsGatewayNo: 1,
    ...SHARED_SMS,
    fromEmail: 'appct@lambda-cro.com',
    password: 'Nor83691',
    tenantId: '71b0e6b2-5dc4-43f6-9743-aac6fefe4fb5',
    clientId: 'affaee00-a518-4387-8eb9-089314607a35',
    secretKey: '',
    clearSecretKey: true,
  },
};

export const detectPresetLabel = (fromEmail) => {
  if (!fromEmail) return '—';
  if (fromEmail === EMAIL_GATEWAY_PRESETS.sarjen.fromEmail) return 'Sarjen';
  if (fromEmail === EMAIL_GATEWAY_PRESETS.ltr.fromEmail) return 'LTR';
  return 'Custom';
};

/** Map preset + optional existing row into modal form state (plain-text secrets). */
export const presetToForm = (presetKey, existingRow) => {
  const preset = EMAIL_GATEWAY_PRESETS[presetKey];
  if (!preset) return null;
  return {
    ...preset,
    smsGatewayNo: existingRow?.smsGatewayNo ?? 0,
    passwordMasked: false,
    secretKeyMasked: false,
    smsPwdMasked: false,
  };
};
